<template>
  <v-container>
    <v-row
      justify="space-between"
      class="mb-2 pa-2"
      style="background-color: #efefef;"
    >
      <span class="ml-8 text-h4 font-weight-light">Carrello Acquisti</span>
    </v-row>

    <v-simple-table
      dense
      class="mb-4"
    >
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">
              Linea
            </th>
            <th class="text-left">
              Part. Code
            </th>
            <th class="text-left">
              Part. Name
            </th>
            <th class="text-left">
              Descrizione
            </th>
            <th class="text-left">
              Q.ta
            </th>
            <th> &nbsp;</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="item in cart"
            :key="`cartrow_${item.codpar}`"
          >
            <td>{{ item.codart }}</td>
            <td>{{ item.codpar }}</td>
            <td>{{ item.descompo }}</td>
            <td class="text-caption">
              {{ item.descompo }}{{ item.sez }} <br>
              [{{ item.numcol }}] {{ item.descol }}
            </td>
            <td>{{ item.qta }}</td>
            <td>
              <v-icon
                color="red"
                small
                @click="cart.splice(cart.indexOf(item),1)"
              >
                mdi-delete
              </v-icon>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <!-- <v-text-field
      v-if="cart.length>0"
      v-model="riferimento"
      dense
      outlined
      label="Riferimento"
    /> -->
    <!-- <v-textarea
      v-if="cart.length>0"
      v-model="details.note"
      label="Note"
      outlined
      rows="2"
      auto-grow
      dense
    /> -->
    <v-row
      justify="end"
      class="pa-2"
      style="background-color: #efefef;"
    >
      <span class="text-caption mr-8 grey--text"> {{ cart.length }} articoli</span>
      <v-spacer />
      <v-btn
        small
        color=""
        :disabled="!cart || cart.length==0"
        @click="$store.commit('setCart', [])"
      >
        <v-icon>
          mdi-cart-off
        </v-icon> Reset
      </v-btn>
      <v-btn
        small
        color="primary"
        :disabled="!cart || cart.length==0"
        @click="$emit('save',details)"
      >
        <v-icon>
          mdi-send
        </v-icon> Invia
      </v-btn>
    </v-row>
  </v-container>
</template>
          <script>
  import { mapState } from 'vuex'

  export default {
    name: 'SparepartsCart',
    data () {
      return {
        details: {},
      }
    },
    computed: {
      ...mapState(['cart']),
      isMobile: function () {
        return this.$vuetify.breakpoint.xsOnly
      },

    },
    watch: {
      cart: function (val) {
        if (val.length === 0) {
          this.details.note = ''
        }
      },
    },
    mounted () {

    },
    destroyed () {

    },
    methods: {

    },
  }
        </script>
